import { useMemo } from 'react';
import { INormalizedLandingElement } from '~/src/services/projects';
import { prepareColumnsToPreview, ILigalItem } from '~/src/services/blocks/preparePreview';
import { ICityData } from '~/src/components/LandingBlock/Header/HeaderPanel';
import * as ST from './styled';

export interface ILigalBlockProps {
    blockId: string,
    ligalColumnCount: {
        desktop: string;
        sDesktop: string;
        table: string;
        mobile: string;
    } | string;
    logo?: string;
    columns: INormalizedLandingElement;
    customStyles?: ST.ILigalBlockStyles;
    isAdmin?: boolean;
    currentBreakpoint?: string;
    background?: string;
    cityData: ICityData | Record<string, never>;
    additionalBlockConfig?: any;
}

const Ligal = ({
    blockId,
    columns,
    customStyles,
    isAdmin,
    currentBreakpoint,
    background,
    cityData = {},
    additionalBlockConfig,
}: ILigalBlockProps): JSX.Element => {
    const { city } = cityData;

    const { logo_narrow = '/landing/icons/domru.svg' } = city || {};

    const items: ILigalItem[] = useMemo(() => {
        return prepareColumnsToPreview(columns, isAdmin, currentBreakpoint);
    }, [columns, currentBreakpoint, isAdmin]);

    return (
        <ST.Wrapper id={blockId} {...customStyles} background={background} {...additionalBlockConfig}>
            <ST.StyledGrid modeName='wide'>
                <ST.Row>
                    {
                        items?.map((item: ILigalItem) => (
                            <ST.LigalItem
                                key={item.key}
                                logo={logo_narrow}
                                {...customStyles}
                                styleKey={item.key.replace(/Ligal\[\d{1,}\]?/, 'Ligal')}
                            >
                                <ST.LigalText
                                    {...customStyles}
                                    styleKey={item.key.replace(/Ligal\[\d{1,}\]?/, 'Ligal') + '.Text'}
                                    dangerouslySetInnerHTML={{ __html: item['text'] }}
                                />
                            </ST.LigalItem>
                        ))
                    }
                </ST.Row>
            </ST.StyledGrid>
        </ST.Wrapper>
    );
};

export default Ligal;
